








































import mixins from 'vue-typed-mixins';
import { PointsOfServiceOptions } from '.';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => PointsOfServiceOptions,
    },
  },
  mounted() {
    // set  values to defaults
    this.$emit('input', {
      address: true,
      singlelabel:
        this.value.singlelabel ||
        this.$languageobj(
          'model.question.options.points_of_service.singlelabel.default'
        ),
      multilabel:
        this.value.multilabel ||
        this.$languageobj(
          'model.question.options.points_of_service.multilabel.default'
        ),
      ...this.value,
    });
  },
});
